import { cn } from "@newxsystems/shared";
import { getBalancedGridColumnCount } from "@templates/design-system";
import { getComponent } from "../../../../client";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import type { ILogoCloudGridProps } from "./LogoCloudGrid.props";

const desktopColumns = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
} as const;

export const LogoCloudGrid = ({ items }: ILogoCloudGridProps) => {
  const Link = getComponent("Link");
  const desktopColumnCount = getBalancedGridColumnCount(items.length);
  return (
    <div
      className={cn(
        "grid border-l border-t border-weathered-steel",
        items.length === 1 ? "grid-cols-1" : "grid-cols-2",
        desktopColumns[desktopColumnCount],
      )}
    >
      {items.map((item, index) => {
        const logo = (
          <GroundMedia
            className="h-28 border-b border-r border-weathered-steel p-6"
            imageClassName="object-contain grayscale transition-[filter] duration-200 group-hover:grayscale-0"
            media={item.logo}
            sizes="180px"
          />
        );
        return (
          <div key={index}>
            {item.logoLink ? (
              <Link
                aria-label={item.logoLink.accessibilityLabel || undefined}
                className="group block focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
                href={item.logoLink.href}
                rel={item.logoLink.openInNewTab ? "noopener noreferrer" : undefined}
                target={item.logoLink.openInNewTab ? "_blank" : undefined}
              >
                {logo}
              </Link>
            ) : (
              logo
            )}
          </div>
        );
      })}
    </div>
  );
};

LogoCloudGrid.displayName = "Content::LogoCloudGrid";
